import { render, staticRenderFns } from "./SetupLeagueGame.vue?vue&type=template&id=69145ba3&scoped=true&"
import script from "./SetupLeagueGame.vue?vue&type=script&lang=js&"
export * from "./SetupLeagueGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69145ba3",
  null
  
)

export default component.exports